module.exports = __webpack_public_path__ + "img/snow_fall_00017.97afb5f9.png";